// src/components/landing/mediaIcons.tsx
import React from "react";
import { Building2, Landmark, MonitorPlay, Bus, ShoppingBag, Wallpaper, Construction } from "lucide-react";

export const MEDIA_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  hoarding: Building2,
  unipole: Landmark,
  led_screen: MonitorPlay,
  gantry: Construction,
  transit_media: Bus,
  mall_kiosk: ShoppingBag,
  wall_wrap: Wallpaper,
};

export function mediaIcon(mediaType: string) {
  return MEDIA_ICONS[mediaType] ?? Building2;
}